var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-auto",attrs:{"color":"primary","icon":"","to":{ name: 'Clientes' },"plain":""}},[_c('v-icon',{staticClass:"me-5"},[_vm._v(" mdi-domain ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }